import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import {ThemeProvider} from "@mui/material/styles";
import {BrowserRouter} from "react-router";
import {_theme} from "./style/theme";
import {C} from "./configurations/active-configuration";
import {FirebaseProvider} from "./services/firebase/FirebaseProvider";
import {RootRoutes} from "./routing/RootRoutes";
import {B} from "./build";
import {shorten} from './utils/js-utils';
import {environment, rollbar} from "./env";
import {FrontEggRootWrapper} from "./authentication/frontegg/FrontEggRootWrapper";
import {Auth0RootWrapper} from "./authentication/auth0/Auth0RootWrapper";
import {ErrorBoundary as RollbarErrorBoundary, Provider as RollbarProvider} from '@rollbar/react';
import type Rollbar from "rollbar";
import {MuiXLicense} from "./configurations/mui/MuiXLicense.tsx";
import {p} from "./stores/init.ts";
import {ChatProvider} from "./pages/chat-agent/context/ChatContext.tsx";

// USED:
// https://react-bootstrap.github.io/layout/grid/#col-props
// https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/File_drag_and_drop
// https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/function_components
// https://react-dnd.github.io/react-dnd/examples/other/native-files
// https://material-ui.com/guides/typescript/

// Future work?
// https://www.typescriptlang.org/docs/handbook/react.html
// https://reactjs.org/docs/hooks-intro.html
// Redux react
// https://www.bergqvist.it/blog/2019/5/17/typing_react_with_typescript

export const App: React.FC = () => {
    // const locale = environment.locale || (window.navigator.language || 'en-GB');
    // moment.locale(locale);

    console.log('APP_IS_DEV:', B.APP_IS_DEV);

    console.log('Version: ' + B.APP_VERSION)
    console.log(`AUTH0_CLIENT_ID: ${shorten(B.AUTH0_CLIENT_ID)} FRONTEGG_APPLICATION_ID: ${shorten(B.FRONTEGG_APPLICATION_ID)}`)
    console.log('AppPackage: ' + String(C.package))

    // Note: The order of the wrappers is from bottom to top!
    let App = <>
        <RootRoutes/>
        <MuiXLicense/>
    </>

    if (p.p.enableProcChat) {
        App = <ChatProvider>{App}</ChatProvider>;
    }
    if (environment.hasAuth0) {
        App = <Auth0RootWrapper>{App}</Auth0RootWrapper>;
    }
    if (environment.hasFrontegg) {
        App = <FrontEggRootWrapper>{App}</FrontEggRootWrapper>;
    }
    App = <FirebaseProvider>{App}</FirebaseProvider>;

    App = <BrowserRouter>
        <ThemeProvider theme={_theme}>
            {App}
        </ThemeProvider>
    </BrowserRouter>

    if(environment.rollbarConfig) {
        App = <RollbarProvider instance={rollbar as Rollbar}>
            <RollbarErrorBoundary>
                {App}
            </RollbarErrorBoundary>
        </RollbarProvider>
    }

    return App
}
